import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function fadeColorImg() {
    const body = document.body;
    const runScrollTrigger = () => {
        const textSections = document.querySelectorAll('.js-fade-color-img');

        textSections.forEach((imgSection) => {
            ScrollTrigger.create({
                trigger: imgSection,
                start: 'top 80%',
                toggleClass: { targets: imgSection, className: 'is-show' },
                once: true,
                markers: false,
            });
        });
    };

    const bodyHasRequiredClass = () => {
        return body.classList.contains('is-overlay-active');
    };

    if (bodyHasRequiredClass()) {
        runScrollTrigger();
    } else {
        const observer = new MutationObserver(() => {
            if (bodyHasRequiredClass()) {
                runScrollTrigger();
                observer.disconnect();
            }
        });

        observer.observe(body, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }
}
